import Accordion from "../../../components/accordion"
import Loading from "../../../components/loading"
import CardStatus from "../../../components/card-status";
import {eventTag} from "../../../services/utils";

export default function Archived({
                                listArchived,
                                updateArchived,
                                loadMore,
                                event = null,
                                callbackCardFinalized,
                              }) {
  const getDisplayKey = (item) => (item.postCreditId && item.isPostCredit) ? `${item.id}${item.postCreditId}` : `${item.id}`;

  return (
    <Accordion
      title={`Planejamentos arquivados`}
      titleLength={listArchived?.count || 0}
      forceHeightUpdate={updateArchived}
      handleClick={() => eventTag(
        event.name,
        event.category,
        event.action,
        "Planejamentos arquivados"
      )}
    >
      {listArchived.loading ? (
        <div className="wrapper-loading-small">
          <Loading small />
        </div>
      ) : null}

      {!!listArchived.count ? (
        listArchived?.results.map((item, k) => {
          const displayKey = getDisplayKey(item);

          return (
            <CardStatus
              key={displayKey}
              data={item}
              isFinished={item.isFinished}
              showDuplicate={false}
              event={event}
              isArchived={true}
              callbackFinalized={(e) => callbackCardFinalized(e)}
            />
          )
        })
      ) : (
        <div className="list-trash" style={{ minHeight: "auto" }}>
          <div className="empty" style={{ padding: '15px 0 35px'}}>
            Nenhum resultado encontrado
          </div>
        </div>
      )}

      {!!listArchived?.next ? (
        <div className="more-planning" style={{ marginTop: "15px", marginBottom: "15px" }}>
          <button type="button" onClick={loadMore}>
            Carregar mais
          </button>
        </div>
      ) : ''}
    </Accordion>
  )
}